import Focus from '../../types/enums/focus';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { setFocus } from '../../store/slices/focus.slice';
import { store } from '../../store/store';

function goToSeriesExtended(id: string) {
  store.dispatch(
    pushRoute({
      route: { Page: Pages.SERIES_EXTENDED },
      params: { current: { id }, push: true },
    })
  );
  store.dispatch(
    setFocus([Focus.RAILS_LIST, parseInt(`${Focus.RAILS_SUB_LIST}0`)])
  );
}

export default goToSeriesExtended;
